import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import { MultiSelect } from "react-multi-select-component";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import usermanagementStore from "../../../Stores/UsermanagementStore";
import UsermanagementConstants from "../../../Constants/UsermanagementConstants";
import UserManagementActions from "../../../Actions/UserManagementActions";

export default function AddResponsibiltyForm(props) {
  const {
    getEqupGrupUserListFlag,
    equipmentGrpId,
    closeAddEditResponsibiltyPopUpCallback,
  } = props;
  const [userList, setUserList] = useState([]);
  const [selectedUserList, setSelectedUserList] = useState([]);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const overrideStrings = {
    selectSomeItems: localization.select,
    search: localization.search,
    selectAll: localization.select + " " + localization.all,
    selectAllFiltered:
      localization.select +
      " " +
      localization.all +
      "(" +
      localization.filtered +
      ")",
    allItemsAreSelected: localization.allItemSelected,
    noOptions: localization.noOptions,
  };

  useEffect(() => {
    if (getEqupGrupUserListFlag) {
      getEquipmentGroupUserList(equipmentGrpId);
    }
  }, [getEqupGrupUserListFlag]);

  const responsibleUserAdd = (e) => {
    e.preventDefault();
    let selectedUserIds = [];
    selectedUserList.map((key, index) => {
      selectedUserIds.push(key.value);
    });

    let userData = {
      AnlagegruppeID: equipmentGrpId,
      UserIDs: selectedUserIds,
    };
    setGlobalSpinner(true);
    UserManagementActions.addResponsibleUserToEqupGroup(userData);
    setSelectedUserList([]);
  };

  const getEquipmentGroupUserList = () => {
    setGlobalSpinner(true);
    UserManagementActions.getEquipmentGroupUsers(equipmentGrpId);
  };

  useEffect(() => {
    function getEquipmentGroupUserSuccess() {
      const res = usermanagementStore.getEqupGrpUserList();
      if (res) {
        let tempList = [];
        res.map((row) => {
          tempList.push({ label: row.name, value: row.id });
        });
        setUserList(tempList);
        setGlobalSpinner(false);
      }
    }

    function getEquipmentGroupUserFailure() {
      var res = usermanagementStore.getEqupGrpUserList();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_USER_SUCCESS,
      getEquipmentGroupUserSuccess
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_USER_FAILURE,
      getEquipmentGroupUserFailure
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_USER_SUCCESS,
        getEquipmentGroupUserSuccess
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_USER_FAILURE,
        getEquipmentGroupUserFailure
      );
    };
  }, []);

  return (
    <div
      className={`modal fade`}
      id="addResForm"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addResForm"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addResForm">
              {localization.addResponsibleUser}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addResFormModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="userAdd" autoComplete="off" onSubmit={responsibleUserAdd}>
            <div className="modal-body">
              {/* <div className="form-outline mb-4">
                <label className="form-label" htmlFor="name">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  required
                  placeholder={"Name"}
                  value={userData.name}
                  onChange={(e) => {
                    e.preventDefault();

                    setUserData((prev) => ({
                      ...prev,
                      name:
                        userData.name !== ""
                          ? e.target.value
                          : e.target.value.trim(),
                    }));
                  }}
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="userName">
                  User Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  required
                  placeholder={"UserName"}
                  value={userData.userName}
                  onChange={(e) => {
                    e.preventDefault();
                    setUserData((prev) => ({
                      ...prev,
                      userName:
                        userData.userName !== ""
                          ? e.target.value
                          : e.target.value.trim(),
                    }));
                  }}
                />
              </div> */}
              <div className="form-group  mb-0" style={{ marginTop: "-1px" }}>
                <MultiSelect
                  options={userList}
                  autosize={false}
                  value={selectedUserList}
                  onChange={setSelectedUserList}
                  labelledBy={localization.selectUsers}
                  closeOnChangedValue={false}
                  overrideStrings={overrideStrings}
                  // className="meltiWidth"
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={selectedUserList && selectedUserList.length == 0}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
